export default __webpack_public_path__ + "static/media/GvLogoWhite.c0bc2f9e.svg";